// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3c95a7c5","455":"6c77c11e","977":"085ae37c"}[chunkId] + ".chunk.js";
};